// import ModalVideo from "react-modal-video"; 
// // import 'react-modal-video/css/modal-video.min.css';
// import 'react-modal-video/scss/modal-video.scss';


// const VideoPopup = ({
//   isVideoOpen,
//   setIsVideoOpen,
//   videoId = "gmOR6AzgyHI", 
  
// } ) => {
//   return (
//     <>
//       <ModalVideo
//         channel="youtube"
//         // autoplay
//         isOpen={isVideoOpen}
//         videoId={videoId}
//         onClose={() => setIsVideoOpen(false)}
        
      
// //          autoplay
  
//       />
//     </>
//   );
// };

// export default VideoPopup;


// import React, { useState } from 'react';
// import ReactDOM from 'react-dom';
// import './VideoModal.css';  // We'll style it separately

// const VideoPopup = ({isVideoOpen,setIsVideoOpen}) => {


//   return (
//     <div>

//       {isVideoOpen && (
//         <div className="video-modal-overlay">
//           <div className="video-modal-content">
//             <button className="close-btn" onClick={() => setIsVideoOpen(false)}>×</button>
//             <video controls autoPlay width="100%" disablePictureInPicture>
//               <source src="your-video.mp4" type="video/mp4" />
//             </video>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default VideoPopup;

import React, { useState } from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  position: relative;
  width: 90%;
  max-width: 720px;
  background: #000;
  border-radius: 10px;
  overflow: hidden;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 30px;
  border: none;
  background: transparent;
  color: white;
  cursor: pointer;
`;

const VideoPopup = ({ isVideoOpen, setIsVideoOpen, videoId = "gmOR6AzgyHI" }) => {
  if (!isVideoOpen) return null;

  return (
    <Overlay>
      <ModalContent>
        <CloseButton onClick={() => setIsVideoOpen(false)}>&times;</CloseButton>
        <iframe
          width="100%"
          height="400"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1&rel=0`}
          title="Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </ModalContent>
    </Overlay>
  );
};

export default VideoPopup;